"use client";
import { setLoading, setLogin, setLogout } from '@/redux/features/auth/AuthSlice';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from '../widget/Loading';
import Api from '@/inc/Api';

class AuthWraper extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount(){
        this.loadUserData();
    }
    loadUserData(){
        this.props.setAuthLoading();
        let api = Api,that = this;
        if(api.setUserToken()){
            api.axios().get('/my-account/me').then(res => {
                if(res.data.type){
                    that.props.login(res.data.data.user);
                }else{
                    that.props.logout();
                }
            }).catch(error => {
                that.props.logout();
            })
        }else{
            this.props.logout();
        }
    }
    render() {
        let auth = this.props.auth;
        if(auth.isLoading){
            return <Loading/>;
        }
        
        if(!auth.isLogin){
            window.location.href = '/login';
            return <Loading/>;
        }
        return (
            <>
                {this.props.children}
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        login: (user) => dispatch( setLogin(user) ),
        logout: () => dispatch( setLogout() ),
        setAuthLoading: () => dispatch( setLoading() ),
    }
};
export default connect(mapStateToProps,mapDispatchToProps)  (AuthWraper);